<template>
  <Transition>
    <div
      v-if="!isOpen"
      style="
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
        padding-inline: 10rem;
        margin-top: 89px;
      "
    >
      <div
        style="display: flex; align-items: baseline; margin-right: 1rem"
        class="field-radiobutton"
      >
        <RadioButton
          ref="jobtypes"
          style="margin-right: 0.5rem"
          inputId="contract"
          name="jobtypes"
          v-bind:value="$t('contract')"
          v-model="jobtypes"
          @change="radioButtonFilters()"
        />
        <label
          style="
            font-family: 'Jost';
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 26px;
            color: #444444;
          "
          for="contract"
        >
          {{ $t('contract') }}
        </label>
      </div>

      <div
        style="display: flex; align-items: baseline; margin-right: 1rem"
        class="field-radiobutton"
      >
        <RadioButton
          ref="jobtypes"
          style="margin-right: 0.5rem"
          inputId="fulltime"
          name="jobtypes"
          v-bind:value="$t('fulltime')"
          v-model="jobtypes"
          @change="radioButtonFilters()"
        />
        <label
          style="
            font-family: 'Jost';
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 26px;
            color: #444444;
          "
          for="fulltime"
        >
          {{ $t('fulltime') }}
        </label>
      </div>

      <div
        style="display: flex; align-items: baseline; margin-right: 1rem"
        class="field-radiobutton"
      >
        <RadioButton
          ref="jobtypes"
          style="margin-right: 0.5rem"
          inputId="partime"
          name="jobtypes"
          v-bind:value="$t('partime')"
          v-model="jobtypes"
          @change="radioButtonFilters()"
        />
        <label
          style="
            font-family: 'Jost';
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 26px;
            color: #444444;
          "
          for="partime"
        >
          {{ $t('partime') }}
        </label>
      </div>
      <div class="button-container">
        <Button
          class="advanced-filter-button"
          @click="toggle"
          :class="{ 'is-filtered': isFilter }"
          style="padding: 0.75rem 1.5rem"
        >
          <i :class="isFilter ? 'pi pi-filter' : 'pi pi-filter-slash'"></i>
        </Button>
      </div>
    </div>
  </Transition>
  <Transition>
    <div
      class="panel"
      style="
        width: 100%;
        background: #e2ecf50a;
        z-index: 999;
        position: relative;
      "
      v-if="isOpen"
    >
      <div
        ref="op"
        appendTo="body"
        id="overlay_panel"
        :breakpoints="{ '960px': '840px', '640px': '600px' }"
        :style="{
          maxWidth: '1258px',
          width: '100%',
          height: '306px',
          margin: '0 auto',
        }"
      >
        <div
          class="panel-header"
          style="
            display: flex;
            justify-content: space-between;
            margin: 2rem;
            border-bottom: 1px solid #dddddd;
            align-items: center;
          "
        >
          <div>
            <label
              style="
                font-family: 'Jost';
                font-style: normal;
                font-weight: 600;
                font-size: 20px;
                line-height: 29px;
                color: #103660;
              "
              class="filter"
            >
              {{ $t('filters') }}
            </label>
          </div>
          <div>
            <Button style="background-color: white" @click="toggle">
              <label
                style="
                  background-color: white;
                  font-family: 'Jost';
                  font-style: normal;
                  font-weight: 600;
                  font-size: 22px;
                  ine-height: 32px;
                  color: #103660;
                  margin-left: 1.5rem;
                "
              >
                X
              </label>
            </Button>
          </div>
        </div>

        <div>
          <table>
            <tr>
              <th>{{ $t('jobtype') }}</th>
              <th>{{ $t('worktype') }}</th>
              <th>{{ $t('dateposted') }}</th>
            </tr>

            <tr>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="alljobs"
                    name="jobtype"
                    :value="$t('alljobs')"
                    v-model="jobtypes"
                    @change="radioButtonFilters()"
                  />
                  <label
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="alljobs"
                    >{{ $t('alljobs') }}</label
                  >
                </div>
              </td>

              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="any"
                    name="worktype"
                    :value="$t('any')"
                    v-model="worktype"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="any"
                  >
                    {{ $t('any') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="any"
                    name="dateposted"
                    :value="$t('any')"
                    v-model="dateposted"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="any"
                  >
                    {{ $t('any') }}</label
                  >
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="fulltime"
                    name="jobtype"
                    :value="$t('fulltime')"
                    v-model="jobtypes"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="fulltime"
                    >{{ $t('fulltime') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="remote"
                    name="worktype"
                    :value="$t('remote')"
                    v-model="worktype"
                    @change="radioButtonFilters()"
                  />
                  <label
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="remote"
                  >
                    {{ $t('remote') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="today"
                    name="dateposted"
                    :value="$t('today')"
                    v-model="dateposted"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="today"
                  >
                    {{ $t('today') }}</label
                  >
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="partime"
                    name="jobtype"
                    :value="$t('partime')"
                    v-model="jobtypes"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="partime"
                    >{{ $t('partime') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="onside"
                    name="worktype"
                    :value="$t('onside')"
                    v-model="worktype"
                    @change="radioButtonFilters()"
                  />
                  <label
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="onside"
                  >
                    {{ $t('onside') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="thisweek"
                    name="dateposted"
                    :value="$t('thisweek')"
                    v-model="dateposted"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="thisweek"
                  >
                    {{ $t('thisweek') }}</label
                  >
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="contract"
                    name="jobtype"
                    :value="$t('contract')"
                    v-model="jobtypes"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="contract"
                    >{{ $t('contract') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="hybrid"
                    name="worktype"
                    :value="$t('hybrid')"
                    v-model="worktype"
                    @change="radioButtonFilters()"
                  />
                  <label
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="onside"
                  >
                    {{ $t('hybrid') }}</label
                  >
                </div>
              </td>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="thismonth"
                    name="dateposted"
                    :value="$t('thismonth')"
                    v-model="dateposted"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="thismonth"
                  >
                    {{ $t('thismonth') }}</label
                  >
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="internship"
                    name="jobtype"
                    :value="$t('internship')"
                    v-model="jobtypes"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="internship"
                    >{{ $t('internship') }}</label
                  >
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td>
                <div class="field-radiobutton">
                  <RadioButton
                    inputId="temporary"
                    name="jobtype"
                    :value="$t('temporary')"
                    v-model="jobtypes"
                    @change="radioButtonFilters()"
                  />
                  <label
                    class="filter-label"
                    style="margin-bottom: 0px !important; margin-left: 0.5rem"
                    for="temporary"
                    >{{ $t('temporary') }}</label
                  >
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        <!-- <div
      class="d-flex justify-content-end gap-4"
        >
          <Button
            @click="clear()"
            style="
              background: rgba(252, 108, 42, 0.11);
              border: 1px solid #fc6c2a;
              border-radius: 5px;
            "
          >
            <label
              style="
                font-weight: 500;
                font-size: 13px;
                line-height: 18px;
                color: rgb(252, 108, 42);
              "
            >
              {{ $t("clear") }}
            </label>
          </Button>
          <Button
            @click="result()"
            style="
              background: rgba(1, 92, 172, 0.2);
              border: 1px solid #015cac;
              border-radius: 5px;
            "
          >
            <label
              style="
                font-weight: 500;
                font-size: 13px;
                line-height: 18px;
                text-align: center;
                color: #015cac;
              "
            >
              {{
                $t('result')
               
              }}
            </label>
          </Button>
        </div>-->
        <div class="d-flex justify-content-end" style="gap: 8px">
          <Button
            @click="clear()"
            :label="$t('clear')"
            style="
              background: rgba(252, 108, 42, 0.11);
              border: 1px solid #fc6c2a;
              border-radius: 5px;
              color: #fc6c2a;
              min-width: 90px;
            "
          />
          <Button
            @click="result()"
            :label="$t('result')"
            style="
              background: rgba(1, 92, 172, 0.2);
              border: 1px solid #015cac;
              border-radius: 5px;
              color: #015cac;
              min-width: 90px;
            "
          />
        </div>
      </div>
    </div>
  </Transition>
</template>
<script>
export default {
  emits: ['clear-click', 'result-click', 'toggle-click', 'radioButton-change'],
  props: {
    filterLength: Number,
    jobtypesProp: {
      type: String,
      default: null,
    },
    worktypeProp: {
      type: String,
      default: null,
    },
    datepostedProp: {
      type: String,
      default: null,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jobtype: null,
      jobtypes: this.jobtypesProp,
      worktype: this.worktypeProp,
      dateposted: this.datepostedProp,
      isOpen: false,
    }
  },
  created() {
    if (this.jobtypes === null) {
      this.jobtypes = this.$t('alljobs')
    }
    if (this.worktype === null) {
      this.worktype = this.$t('any')
    }
    if (this.dateposted === null) {
      this.dateposted = this.$t('any')
    }
  },
  watch: {
    // Watch for changes in props to update local data
    jobtypesProp: {
      handler(newValue) {
        this.jobtypes = newValue || this.$t('alljobs')
      },
      immediate: true,
    },
    worktypeProp: {
      handler(newValue) {
        this.worktype = newValue || this.$t('any')
      },
      immediate: true,
    },
    datepostedProp: {
      handler(newValue) {
        this.dateposted = newValue || this.$t('any')
      },
      immediate: true,
    },
  },
  methods: {
    radioButtonFilters() {
      let paramObj = {}
      paramObj.jobTypes = this.jobtypes
      paramObj.workTypes = this.worktype
      paramObj.datePosteds = this.dateposted
      this.$emit('radioButton-change', paramObj, 'radiobutton')
    },

    clear() {
      // Reset the values
      this.jobtypes = this.$t('alljobs')
      this.worktype = this.$t('any')
      this.dateposted = this.$t('any')

      // Emit the clear event to notify parent component
      this.$emit('clear-click')

      // Close the filter panel if it's open
      if (this.isOpen) {
        this.isOpen = false
        this.$emit('toggle-click', this.isOpen)
      }
    },

    result() {
      this.$emit('result-click')
    },

    toggle() {
      //
      this.isOpen = !this.isOpen

      this.$emit('toggle-click', this.isOpen)
      //   this.$refs.table.$refs.table.attributes.class.ownerElement.offsetParent.children[1].children[3].children[3].style.top='-31rem';

      //   this.$refs.table.$refs.table.attributes.class.ownerElement.offsetParent.children[1].children[3].children[3].style.top='-7.1rem';
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep(.p-checkbox .p-checkbox-box.p-highlight) {
  border-color: #fc6c2a;
  background: #fc6c2a;
  border-radius: 6px;
}
::v-deep(label) {
  margin-bottom: 0px !important;
}
.filter-label {
  font-family: 'Jost';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 172%;
  color: #103660;
}

table {
  font-family: 'Jost';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 172%;
  color: #103660;
  border-collapse: collapse;
  width: 100%;
  margin-left: 4rem;
  margin-top: 2rem;
}

td,
th {
  text-align: left;
  // padding: 8px;
}
::v-deep(.p-radiobutton-icon) {
  transform: translateZ(0) scale(1, 1) translate(-3.5%, -5%);
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
div[data-v-ded5c94a] {
  @media (max-width: 500px) {
    padding: 0px !important;
  }
}
</style>
